import axios from "axios";

// Set up request interceptor to add token to all requests
axios.interceptors.request.use(
  (config) => {
    console.log(`[Axios] Config: ${config}`);
    const token = localStorage.getItem("authToken");
    console.log(`[Axios] Token: ${token}`);
    if (token) {
      config.headers["Authorization"] = `Token ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axios;